var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "parameters m-b-20 hidden" },
        _vm._l(_vm.parameters, function(parameter) {
          return _c(
            "div",
            { key: parameter.name, staticClass: "parameter" },
            [
              _c("ReportingMetricToggle", {
                attrs: {
                  parameter: parameter,
                  "total-value": parameter.totalValue,
                  selected: _vm.selectedParamsMap[parameter.name]
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.handleOnParameterClick(parameter)
                  }
                }
              })
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }